const emailjsConfig = {
  SERVICE_ID: "service_8o3nbd8",
  TEMPLATE_ID: "template_lqqt2ue",
  TEMPLATE2_ID: "template_ap3j8cm",
  USER_ID: "user_xvA2lHDABMtsAYxGfYavn",
};

export default emailjsConfig;
